// src/hooks/usePerformanceSummary.js
import { useQuery } from '@tanstack/react-query';
import api from '../api';

// `summary` is attached to every /api/track/ response regardless of
// filters/pagination, so limit=1 is enough to get it without pulling the
// full bet list.
async function fetchPerformanceSummary({ signal }) {
  const res = await api.get('track/', { params: { limit: 1 }, signal });
  return res.data?.summary ?? null;
}

// Backend caches the summary for 120s — poll on the same cadence so the
// banner picks up fresh results without over-fetching.
export function usePerformanceSummary() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['performance-summary'],
    queryFn: fetchPerformanceSummary,
    staleTime: 120_000,
    refetchInterval: 120_000,
  });
  return { summary: data ?? null, loading: isLoading, error: isError };
}
